import "./IconTilePartner.scss";

import clsx from "clsx";
import { FCC } from "types";

interface Props {
  icon?: JSX.Element;
  label?: string;
  selected?: boolean;
  onClick?: () => void;
  dataTestId?: string;
}

export const IconTile: FCC<Props> = ({
  icon,
  label,
  selected,
  onClick,
  dataTestId = "icon-tile",
}) => (
  <button
    aria-label={label}
    className={clsx("icon-tile-partner", selected && "selected")}
    onClick={onClick}
    data-testid={dataTestId}
  >
    {icon && <div className="icon-container-partner">{icon}</div>}
    <p className="label-container-partner">{label}</p>
  </button>
);
